import { serializeParams } from "@/utils/apiUtils";
import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../common/api/ApiRequestAdapter";
import { apiService } from "../../common/api/apiService";
import { HttpMethod } from "../../common/api/http";
import { PageSizes } from "../../common/constants";
import { EntityIdObject, EntityObject } from "../../common/types";
import { Complicity, ComplicityFilterPageRequest, ComplicityFilterPageResult, CreateUpdateComplicity } from "./types";

const FILTER_COMPLICITIES = ApiRequestAdapter.create("/complicities", HttpMethod.GET);
const CREATE_COMPLICITY = ApiRequestAdapter.create("/complicities", HttpMethod.POST);
const UPDATE_COMPLICITY = ApiRequestAdapter.create("/complicities/{0}", HttpMethod.PUT);
const DELETE_COMPLICITY = ApiRequestAdapter.create("/complicities/{0}", HttpMethod.DELETE);

export const complicityApi = {
  filterComplicities: (request: ComplicityFilterPageRequest): AxiosPromise<ComplicityFilterPageResult> => {
    return apiService.get(FILTER_COMPLICITIES.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
    });
  },
  createComplicity: (request: CreateUpdateComplicity): AxiosPromise<Complicity> => {
    return apiService.post(CREATE_COMPLICITY.url, request);
  },
  updateComplicity: (request: EntityObject<CreateUpdateComplicity>): AxiosPromise<Complicity> => {
    return apiService.put(UPDATE_COMPLICITY.getParametrizedUrl(request.id), request.object);
  },
  deleteComplicity: (request: EntityIdObject): AxiosPromise => {
    return apiService.delete(DELETE_COMPLICITY.getParametrizedUrl(request.id));
  },
};

export const DEFAULT_FILTER_COMPLICITIES_QUERY_PARAMS: Required<ComplicityFilterPageRequest> = {
  institutionIds: [],
  pageIndex: 0,
  pageSize: PageSizes.LARGE,
};
